import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from 'app/core/hooks'

/**
 * ======================================================================
 * @ 업무설명 : 오브젠 통계자료 수집 컴포넌트
 * @ 파 일 명 : src/ObzenTracker.tsx
 * ======================================================================
 * 번호  작업자           작업일         변경내용
 * ======================================================================
 * 1     김병재(S26378)   2025.07.18     최초작성
 * ======================================================================
 */

const ObzenTracker = () => {
    const location = useLocation()
    const pAllPdcd = useAppSelector((state: any) => state.joinProduct.allPdcd) // 상품코드
    let pNfchPrcfGrpCd = useAppSelector(
        (state: any) => state.joinProduct.nfchPrcfGrpCd
    ) // 상품코드
    const pProductMain = useAppSelector((state) => state.productMain)
    if (!pNfchPrcfGrpCd) pNfchPrcfGrpCd = pProductMain.catlDcd

    const pPdm = useAppSelector((state: any) => state.joinProduct.pdm)
    const pComboFlage = useAppSelector(
        (state: any) => state.joinProduct.comboFlage
    )
    const pPathname = location.pathname
    const pSearch = location.search

    let to = pPathname + pSearch
    if (
        pPathname === '/prd/man/PRDMAN0101' ||
        pPathname === '/prd/dep/PRDDEP0102' ||
        pPathname === '/prd/crd/PRDCRD0202'
    ) {
        to = pPathname + '?GRPCD=' + pNfchPrcfGrpCd
    }

    const from = sessionStorage.getItem('obz_prePath') || ''
    React.useEffect(() => {
        if (pPathname.indexOf('/M0') === -1) {
            //const step(미정) = 변수값;
            // url - origin 변경
            if (globalThis._paq) {
                globalThis._paq.push(['setCustomUrl', window.location.origin])
            }
            // obzen Tag Manager 이벤트 푸시
            if (globalThis._mtm) {
                globalThis._mtm.push({
                    event: 'MBB_SPA_PAGE_LOAD',
                    OBZ_FROM_URL: from,
                    OBZ_TO_URL: to,

                    // 추가 수집 항목 - DataLayer 변수명
                    PD_GR_CD: pNfchPrcfGrpCd,
                    PD_CD: pAllPdcd,
                    PD_NM: pPdm,
                    COMBO_FLAG: pComboFlage,
                    //PAGE_STEP : step
                })
            }
            sessionStorage.setItem('obz_prePath', to)
        }
    }, [location])
    return null
}

export default ObzenTracker
